






















import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class Achievements extends Vue {
  private links = [
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fgroup.jpg?alt=media&token=f2a951f1-f120-4e95-9ce1-993776499327',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fnon.jpg?alt=media&token=bfd5d6c4-66fa-4403-a24e-8d231d2057e6',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fcherry.jpg?alt=media&token=884a2e67-ba39-454f-ad09-e33580ef04f5',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fbook.jpg?alt=media&token=9437c319-21da-4930-b25f-ff9169968a4b',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fperm.jpg?alt=media&token=b6970ded-ff70-4caf-8fb6-d7237d718f1f',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fpob.jpg?alt=media&token=3c45ebbf-a7f7-4615-b7f7-2007414506e9',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fgot.jpg?alt=media&token=690bf6e2-c83b-498a-9f42-02b406bf4d5c',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fpraow.jpg?alt=media&token=fcb26d42-8630-407a-aa7b-c091ce49231c',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Ftete.jpg?alt=media&token=77735073-456d-4890-9c98-d5ee750efcc5',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fjade.jpg?alt=media&token=b7bb4fdd-2e1f-403f-87c6-e16fe32f265d',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fmark.jpg?alt=media&token=3de47b69-a3fe-4c7e-81ab-4903dc2d380a',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fpoom.jpg?alt=media&token=74049453-913c-46db-8fff-00ee9fabb9c3',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fmild.jpg?alt=media&token=edc5ad6e-cbd4-4ce6-9929-25d0a5b9c8dd',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fnink.jpg?alt=media&token=d706e53b-6203-46d6-a07e-5fb9a8402033',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fpench.jpg?alt=media&token=4c5c911b-0c20-40f5-bc09-73f9928d39b9',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fbam.jpg?alt=media&token=767bdf40-57f1-4112-80bc-df8e650438bd',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fmook.jpg?alt=media&token=568e4682-4c76-4fed-8cbb-32131c126334',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Faimmy.jpg?alt=media&token=6b06fd5f-2799-4c29-929d-34b33beac75f',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Ftan.jpg?alt=media&token=9790fbe9-bdb7-43d1-a3f9-4dc5e9592823',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fpriew.jpg?alt=media&token=abdea41f-4752-401e-a88e-ce279ba0860d',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Ftcas%2Fkaooat.jpg?alt=media&token=0a4a78f7-18d6-4edc-8c52-915cbc793d90',
  ];
}
